import { render, staticRenderFns } from "./TacticsThree.vue?vue&type=template&id=63d04d64&scoped=true"
var script = {}
import style0 from "./TacticsThree.vue?vue&type=style&index=0&id=63d04d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d04d64",
  null
  
)

export default component.exports